import React from 'react'
import clsx from 'clsx'
import WorkItemTitleRowActions from '@Components/WorkItem/WorkItemTitleRow/WorkItemTitleRowActions'

interface WorkItemTitleRowProps {
    title: string
    extendedInfoIsOpen: boolean
    onToggleExtendedInfo: () => void
    viewDetails: () => void
    publicSearchType?: boolean
    claimType?: boolean
    historyType?: boolean
    draftType?: boolean
    songCode?: string | null
    id?: number | null
    catalogPath: string
    onCatalogClick?: () => void
    handleDeleteDraft?: () => void
    registrationHistoryStatus?: string | null
    registrationHistoryDate?: string | null
    selectWorkForMatching?: (songCode: string, title: string) => void
    selectWorkForClaiming?: (propertyId: number | null | undefined) => void
}

const WorkItemTitleRow = ({
    title,
    extendedInfoIsOpen,
    onToggleExtendedInfo,
    viewDetails,
    publicSearchType,
    claimType,
    historyType,
    draftType,
    songCode,
    id,
    catalogPath,
    onCatalogClick,
    handleDeleteDraft,
    registrationHistoryStatus,
    registrationHistoryDate,
    selectWorkForMatching,
    selectWorkForClaiming,
}: WorkItemTitleRowProps) => (
    <div className="title-view">
        <div className="title" onClick={() => (publicSearchType ? onToggleExtendedInfo() : viewDetails())}>
            <div className="name-block">
                <h5 className="name" title={title}>
                    {title}
                </h5>
            </div>
            {extendedInfoIsOpen && <p>MLC Public Record</p>}
        </div>
        <div className={clsx('right-content', extendedInfoIsOpen && 'right-extended-info')}>
            <WorkItemTitleRowActions
                title={title}
                extendedInfoIsOpen={extendedInfoIsOpen}
                onToggleExtendedInfo={onToggleExtendedInfo}
                publicSearchType={publicSearchType}
                claimType={claimType}
                historyType={historyType}
                draftType={draftType}
                songCode={songCode}
                id={id}
                catalogPath={catalogPath}
                onCatalogClick={onCatalogClick}
                handleDeleteDraft={handleDeleteDraft}
                registrationHistoryStatus={registrationHistoryStatus}
                registrationHistoryDate={registrationHistoryDate}
                selectWorkForMatching={selectWorkForMatching}
                selectWorkForClaiming={selectWorkForClaiming}
            />
        </div>
    </div>
)

export default WorkItemTitleRow
